// constants
import { PayoutActionTypes } from "./constants";

export interface PayoutActionType {
  type:
    | PayoutActionTypes.API_RESPONSE_SUCCESS
    | PayoutActionTypes.API_RESPONSE_ERROR
    | PayoutActionTypes.GET_PAYOUT_BY_INFLUENCER
    | PayoutActionTypes.GET_PAYOUT_DETAILS;
  payload: {} | string;
}

// common success
export const payoutApiResponseSuccess = (actionType: string, data: any | {}): PayoutActionType => ({
  type: PayoutActionTypes.API_RESPONSE_SUCCESS,
  payload: { actionType, data },
});
// common error
export const payoutApiResponseError = (actionType: string, error: string): PayoutActionType => ({
  type: PayoutActionTypes.API_RESPONSE_ERROR,
  payload: { actionType, error },
});

export const getPayout = (influencer_id: any, type?: any, from?: any, to?: any): PayoutActionType => {
  
  return {
    type: PayoutActionTypes.GET_PAYOUT_BY_INFLUENCER,
    payload: {
      influencer_id,
      type,
      from,
      to,
    },
  };
};

export const getPayoutDetails = (influencer_id: any, from?: any, to?: any): PayoutActionType => {
  
  return {
    type: PayoutActionTypes.GET_PAYOUT_DETAILS,
    payload: {
      influencer_id,
      from,
      to,
    },
  };
};
